import { createFileRoute, redirect } from '@tanstack/react-router';
import { normalizeContentSearch } from '@/lib/route-search';

export const Route = createFileRoute('/posts/')({
  beforeLoad: () => {
    throw redirect({ to: '/content', search: normalizeContentSearch({ tab: 'posts' }) });
  },
});
